import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent
} from '@angular/common/http';
import { Observable } from 'rxjs';
import {LocalstorageService} from "../Localstorage/localstorage.service";

@Injectable()
export class ZoneInterceptor implements HttpInterceptor {

  constructor(private localstorageService: LocalstorageService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Get the current fuseau horaire from localStorage service
    const fuseauHoraire = this.localstorageService.getFuseauHoraire();
    const zoneHeader = fuseauHoraire != null && fuseauHoraire !== ''
      ? String(fuseauHoraire)
      : 'Africa/Tunis';

    // Clone the request and add the X-ZONE-ID header
    const clonedRequest = req.clone({
      setHeaders: {
        'X-Timezone': zoneHeader
      }
    });

    // Pass the cloned request with the header to the next handler
    return next.handle(clonedRequest);
  }
}
